import useClickOutside from '@/hooks/use-click-outside';
import { cn } from '@/lib/utils';
import { useRef, useState } from 'react';

const HoverClickStay = ({
  tether,
  children,
  className,
}: {
  tether: React.ReactNode;
  children: React.ReactNode;
  className?: string;
}) => {
  const [wrapperHasClickFocus, setWrapperHasClickFocus] = useState(false);
  const wrapperRef = useRef<HTMLDivElement>(null);
  useClickOutside(wrapperRef, () => {
    setWrapperHasClickFocus(false);
  });

  return (
    <div
      className={cn(
        'flex flex-row gap-2 group items-center w-full justify-start',
        className,
      )}
      ref={wrapperRef}
      onClick={() => setWrapperHasClickFocus(true)}
    >
      {children}
      <div
        className={cn(
          'flex group-hover:opacity-100',
          {
            'opacity-100': wrapperHasClickFocus,
            'opacity-0': !wrapperHasClickFocus,
          },
          // wrapperHasClickFocus && "flex opacity-100"
        )}
      >
        {tether}
      </div>
    </div>
  );
};

export default HoverClickStay;
